(function($) {
	if ($('.hv-slider').length) {
		initSliders();
	}

	function initSliders() {
		var sliders = $('.hv-slider');
		sliders.each(function(){
			gotoSlide($(this),0);
			if ($(this).attr('slide-auto')=="true") {		
				var timing = $(this).attr('slide-duration');
				setTimeout(function(){
					nextSlide($(this));
				}.bind(this),timing);
			}
		});

		$('.hv-slider__pagination span').on('click',function(){
			if (!$(this).hasClass('current')) {
				var index 	= $(this).parent().find('span').index($(this));
				var slider 	= $(this).closest('.hv-slider');
				slider.attr('slide-auto','false');
				gotoSlide(slider,index);
			}
		});
	}

	function nextSlide(slider) {
		var auto 			= slider.attr('slide-auto');
		if (auto == "true") {
			var timing 			= slider.attr('slide-duration');
			var $sliderImages	= slider.find('.hv-slider__slides .slide');
			var $currentSlide 	= $sliderImages.filter('.current');
			var currentIndex 	= $sliderImages.index($currentSlide);
			var maxIndex		= $sliderImages.length;
			var newIndex 		= currentIndex + 1;
			if (newIndex >= maxIndex) {
				newIndex = 0;
			}
			gotoSlide(slider,newIndex);
			setTimeout(function(){
				nextSlide(slider);
			}.bind(slider),timing);
		}
	}

	function gotoSlide(slider,slideNum) {
		// change pagination
		slider.find('.hv-slider__pagination').each(function(){
			$(this).find('span').eq(slideNum).addClass('current').siblings().removeClass('current');
		}) 

		// change slide and slide overlay info
		var $newSlide 		= slider.find('.hv-slider__slides .slide').eq(slideNum);
		var $newSlideMeta	= $newSlide.find('span');


		var newType 		= $newSlide.attr('slide-type');
		var newTitle 		= $newSlideMeta.filter('[title]').text();
		var newSubtitle		= $newSlideMeta.filter('[subtitle]').text();
		if (newType=="Theme") {
			var newTheme 		= $newSlideMeta.filter('[themeName]').text();
			var newThemeLink	= $newSlideMeta.filter('[themeURL]').text();
		}
		if (newType=="Destination") {
			var newDest 		= $newSlideMeta.filter('[destName]').text();
			var newDestLink		= $newSlideMeta.filter('[destURL]').text();
		}
		if (newType=="Villa") {
			var newVilla 		= $newSlideMeta.filter('[villaName]').text();
			var newVillaLink		= $newSlideMeta.filter('[villaURL]').text();
		}

		// fade out current slide and afterwards fade in the new one
		slider.find('.hv-slider__slides .slide.current').fadeOut(function(){
			$newSlide.addClass('current').siblings().removeClass('current');
			$newSlide.fadeIn();
		});

		// fade out current slide overlay info and afterwards fade in the new info
		slider.find('.hv-slider__overlay__top h1').fadeOut(function(){
			slider.find('.hv-slider__overlay__top h1').text(newTitle).fadeIn(800);
		});
		slider.find('.hv-slider__overlay__top span').fadeOut(function(){
			slider.find('.hv-slider__overlay__top span').text(newSubtitle).fadeIn();
		});
		slider.find('.hv-slider__cta span, .hv-slider__cta a').fadeOut(function(){
			if (newType=="Theme") {
				slider.find('.hv-slider__cta span:nth-of-type(1)').text('Featured Theme').fadeIn();
				slider.find('.hv-slider__cta span:nth-of-type(2)').text(newTheme).fadeIn();
				slider.find('.hv-slider__cta a').attr('href',newThemeLink).text('Explore Theme').fadeIn();
			}
			if (newType=="Destination") {
				slider.find('.hv-slider__cta span:nth-of-type(1)').text('Featured Destination').fadeIn();
				slider.find('.hv-slider__cta span:nth-of-type(2)').text(newDest).fadeIn();
				slider.find('.hv-slider__cta a').attr('href',newDestLink).text('Explore Destination').fadeIn();
			}
			if (newType=="Villa") {
				slider.find('.hv-slider__cta span:nth-of-type(1)').text('Featured Villa').fadeIn();
				slider.find('.hv-slider__cta span:nth-of-type(2)').text(newVilla).fadeIn();
				slider.find('.hv-slider__cta a').attr('href',newVillaLink).text('Explore Villa').fadeIn();
			}
		});
	}

	var mX = 0;
	var drag = false;
	var nextIndex;
	var delta;
	var diff;

	$('.hv-slider').on('mousedown touchstart', function(e) {
		drag = true;

		if (e.type == 'mousedown') {
			mX = e.pageX;
		}
		if (e.type == 'touchstart') {
			mX = e.originalEvent.touches[0].pageX;
		}
	});

	$('.hv-slider').on('mousemove touchmove', function(e) {
		var carouselItems	= $(this).find('.slide');
		var currentItem 	= carouselItems.filter('.current');
		var currentIndex 	= carouselItems.index(currentItem);
		var maxIndex 		= carouselItems.length - 1;

		if (drag == true) {
			var direction, eX;
			if (e.type == 'mousemove') eX = e.pageX;
			if (e.type == 'touchmove') eX = e.originalEvent.touches[0].pageX;

			if (mX != eX) {
				diff = mX - eX;
				delta = diff > 0 ? 1 : -1;

				nextIndex = currentIndex + delta;
				if (nextIndex > maxIndex) nextIndex = 0;
				if (nextIndex < 0) nextIndex = maxIndex;
			}
			mX = eX;
		}
	});
	
	$('.hv-slider').on('mouseup touchend', function(e) {
		if (drag && delta !== undefined) {
			var carousel = $(this);
			if (diff > 5 || diff < -5) {
				carousel.attr('slide-auto','false');
				gotoSlide(carousel, nextIndex, delta);
			}
			drag = false;
			delta = undefined;
			diff = null;
		}
	});

})( jQuery );
